import React, { useState, useEffect } from 'react';
import './ProshowArtists.css';
import thamarasseryImg from '../../assets/Thamarassery-churam.jpeg';
import thakajamImg from '../../assets/thakajam.jpeg';
import thudwiserImg from '../../assets/thudwiser.jpeg';
import thirumaliImg from '../../assets/thirumali.jpeg';
import djmaxImg from '../../assets/djmax.jpeg';

const ProshowArtists = () => {
    const cards = [
        { date: '01', month: 'DAY', image: thakajamImg, name: '' },
        { date: '02', month: 'DAY', image: djmaxImg, name: '' },
        { date: '02', month: 'DAY', image: thudwiserImg, name: 'THUDWISER' },
        { date: '02', month: 'DAY', image: thirumaliImg, name: 'THIRUMALI' },
    ];

    const [rotation, setRotation] = useState(0);

    // Auto-rotate the carousel
    useEffect(() => {
        const interval = setInterval(() => {
            setRotation(prev => prev - 90); // 360 / 4 cards = 90 degrees per step
        }, 3000); // Rotate every 3 seconds

        return () => clearInterval(interval);
    }, []);

    const renderCard = (card) => (
        <div className="proshow-card-inner">
            <div className="proshow-card" style={{ backgroundImage: `url(https://ragam.co.in/images/proshow/proshowCardBg.png)` }}>
                {card.name && <div className="artist-name-label">{card.name}</div>}
                <div className="card-content">
                    <div className="card-date">
                        <div className="date-wrapper">
                            <span className="date-day">{card.date}</span>
                            <span className="date-month">{card.month}</span>
                        </div>
                    </div>
                    <div className="card-image-wrapper">
                        <img src={card.image} alt={card.name || "ARTIST"} className="card-artist-img" />
                    </div>
                </div>
            </div>
            {/* Reflection within the card context */}
            <div className="proshow-card-reflection">
                <div className="proshow-card" style={{ backgroundImage: `url(https://ragam.co.in/images/proshow/proshowCardBg.png)` }}>
                    {card.name && <div className="artist-name-label">{card.name}</div>}
                    <div className="card-content">
                        <div className="card-date">
                            <div className="date-wrapper">
                                <span className="date-day">{card.date}</span>
                                <span className="date-month">{card.month}</span>
                            </div>
                        </div>
                        <div className="card-image-wrapper">
                            <img src={card.image} alt={card.name || "ARTIST"} className="card-artist-img" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div className="proshow-section" id="proshow">
            <h1 className="proshow-title">
                <span className="proshow-text-main">
                    PROSHOW
                </span>
                <span className="proshow-text-sub">
                    Artists
                </span>
            </h1>

            <div className="proshow-scene">
                <div
                    className="proshow-carousel-3d"
                    style={{ transform: `rotateY(${rotation}deg)` }}
                >
                    {cards.map((card, index) => {
                        const angle = index * 90; // 360 / 4 cards
                        return (
                            <div
                                key={index}
                                className="proshow-card-wrapper-3d"
                                style={{ transform: `rotateY(${angle}deg) translateZ(400px)` }}
                            >
                                {renderCard(card)}
                            </div>
                        );
                    })}
                </div>
            </div>



            {/* SVG Filter for water ripple */}
            <svg style={{ width: 0, height: 0, position: 'absolute', zIndex: -1 }}>
                <filter id="water-ripple">
                    <feTurbulence type="fractalNoise" baseFrequency="0.015 0.05" numOctaves="2" result="noise"></feTurbulence>
                    <feDisplacementMap in="SourceGraphic" in2="noise" scale="10" xChannelSelector="R" yChannelSelector="G"></feDisplacementMap>
                </filter>
            </svg>
        </div>
    );
};

export default ProshowArtists;
